import { getBoApiBasePath } from 'apps/core/utils/services';
import { GET } from 'service/REST';

export const authCheck = (initCheck: boolean): Promise<Response> =>
  GET(getBoApiBasePath('/metadata'), undefined, initCheck);
